import { render, staticRenderFns } from "./OrthoKneePain.vue?vue&type=template&id=648c12fd&scoped=true"
import script from "./OrthoKneePain.vue?vue&type=script&lang=js"
export * from "./OrthoKneePain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648c12fd",
  null
  
)

export default component.exports